var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.remainingSeconds !== null,
          expression: "remainingSeconds !== null",
        },
      ],
    },
    [
      !_vm.expired
        ? _c("ui-alert", {
            attrs: { type: "info" },
            scopedSlots: _vm._u(
              [
                {
                  key: "description",
                  fn: function () {
                    return [
                      _vm.isUpdate
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.i18nComputed.updateDescription) +
                                "\n        "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n      " +
                                _vm._s(
                                  _vm.i18nComputed.updateDescriptionWithLink
                                ) +
                                "\n      "
                            ),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.openEdit.apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.i18n.editTheAd))]
                            ),
                          ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2654745466
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }